import React from "react";
import {useRecoilValue} from "recoil";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {Breadcrumb, Col, Row} from "antd";
import {globalBreadCrumbState} from "../../../_common/global_state";

export const Breadcrumb_4 = () => {
    const {t} = useTranslation();
    const navigate = useNavigate();

    const globalBreadCrumb = useRecoilValue(globalBreadCrumbState);

    const breadcrumbItems = Array.isArray(globalBreadCrumb) && globalBreadCrumb?.length > 0 && globalBreadCrumb?.map((item, index) => ({
        title: (
            <div
                className={"cursor-pointer"}
                style={index === globalBreadCrumb.length - 1 ? {color: "var(--primary-text-color)"} : {color: "var(--secondary-text-color)"}}
                onClick={() => navigate(item?.path)}
            >
                {t(`module.${item?.name?.replace(".", "").replace(/[-\s+]/g, "_").toLowerCase()}`)}
            </div>
        ),
    }));

    return (
        <Row>
            <Col span={24} className={"mb-2"}>
                <Breadcrumb
                    className={"mx-auto lg:mx-0 w-fit"}
                    separator={">"}
                    items={breadcrumbItems}
                />
            </Col>
        </Row>
    );
};
